/* lawyerVerification — مَنطق الشّارة + تَسميات صَنف نقابة المحامين العراقيّين. */

/** يَصِف صَنف بِطاقة النّقابة بِالعَربيّة:
 *  أ = محامي تمييز (الدّرجة الأُولى)
 *  ب = محامي استئناف (الدّرجة الثّانية)
 *  ج = محامي بداءة (الدّرجة الثّالثة)
 *  د = نادراً ما تُستَخدَم (مُتَدَرِّب)
 */
const GRADE_TITLES = {
  "أ": { short: "أ", letterName: "ألف", full: "محامي تَمييز", color: "#D4AF37" },
  "ا": { short: "أ", letterName: "ألف", full: "محامي تَمييز", color: "#D4AF37" },
  "ب": { short: "ب", letterName: "باء", full: "محامي استئناف", color: "#3B82F6" },
  "ج": { short: "ج", letterName: "جيم", full: "محامي بَداءة",   color: "#22C55E" },
  "د": { short: "د", letterName: "دال", full: "محامٍ مُتَدَرِّب", color: "#94A3B8" },
};

export function gradeLabel(grade) {
  if (!grade) return null;
  const k = (grade || "").trim().charAt(0);
  return GRADE_TITLES[k] || null;
}

/** هل المحامي مُوَثَّق؟ يَعتَمد على bar_id_number + bar_barcode + سَريان البِطاقة. */
export function isVerified(user) {
  if (!user) return false;
  // الـ /api/lawyers/{slug} و /api/lawyers/public يُرجِعان حقل `verified` مُحَسَّب من الخَلفيّة
  if (typeof user.verified === "boolean") return user.verified;
  // للحساب الحاليّ من /auth/me — نُحاسِب يَدويّاً
  const hasId = !!(user.bar_id_number || "").trim();
  const hasBarcode = !!(user.bar_barcode || "").trim();
  const expiry = (user.bar_validity_until || "").trim();
  if (!hasId || !hasBarcode) return false;
  if (!expiry) return true; // إن لَم نَعرف نَعتَبرها سارية
  // تَحليل تاريخ DD/MM/YYYY أو YYYY-MM-DD
  const m = expiry.match(/^(\d{1,4})[/\-.](\d{1,2})[/\-.](\d{1,4})$/);
  if (!m) return true;
  let [_, a, b, c] = m;
  let y, mo, d;
  if (+a > 1900) { y = +a; mo = +b; d = +c; }
  else if (+c > 1900) { d = +a; mo = +b; y = +c; }
  else return true;
  const until = new Date(y, mo - 1, d);
  return until >= new Date();
}
